import React, { useEffect, useState } from "react";
import { Skeleton } from "primereact/skeleton";
import Noimage from "../../images/3.png";
import "./SingleProductCycles.css";

export default function SingleProductCycles() {
  const productId = sessionStorage.getItem("productId");

  const [product, setProduct] = useState([]);
  const [productImg, setProductImg] = useState([]);
  const [mainImage, setMainImage] = useState("");

  useEffect(() => {
    if (productId) {
      fetchProductDetails();
      fetchProductImages();
    }
  }, [productId]);

  const fetchProductDetails = async () => {
    try {
      const res = await fetch(`/allCyclesByPID/${productId}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Invalid product format");
      setProduct(data);
    } catch (err) {
      console.error("Error fetching product:", err.message);
    }
  };

  const fetchProductImages = async () => {
    try {
      const res = await fetch(`/allProductsMediaByPID/${productId}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Invalid media format");
      setProductImg(data);
      if (data.length > 0) {
        setMainImage(`data:image/png;base64,${data[0].productImages}`);
      }
    } catch (err) {
      console.error("Error fetching images:", err.message);
    }
  };

  const handleThumbnailClick = (img) => {
    setMainImage(`data:image/png;base64,${img.productImages}`);
  };

  const renderSpec = (label, value) => {
    if (!value) return null;
    return (
      <div className="spec-row">
        <strong>{label}:</strong>
        <span>{value}</span>
      </div>
    );
  };

  return (
    <>
      <div className="product-container">
        <div className="product-thumbnails">
          {productImg.map((img, idx) => (
            <img
              key={idx}
              src={`data:image/png;base64,${img.productImages}`}
              alt="Thumb"
              onClick={() => handleThumbnailClick(img)}
              className={`thumbnail ${
                mainImage.includes(img.productImages) ? "active" : ""
              }`}
            />
          ))}
        </div>

        <div className="product-main-image">
          <img
            src={mainImage || Noimage}
            alt="Main Product"
            className="main-image"
          />
        </div>

        <div className="product-details">
          {product.map((prdct) => (
            <div key={prdct.productID}>
              <h2>{prdct.productName}</h2>
              <p>
                <strong>Price:</strong>{" "}
                <span className="price">₹{prdct.price}</span>
              </p>
              <p>
                <strong>Age Group:</strong> {prdct.ageGroup}
              </p>
              <p>
                <strong>Brand:</strong> {prdct.brand}
              </p>

              <a
                href={`https://wa.me/919490384177?text=Hi, I'm interested in buying the product: ${encodeURIComponent(
                  prdct.productName
                )}, Price: ₹${prdct.price}`}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-button"
              >
                Shop on WhatsApp
              </a>
            </div>
          ))}
        </div>
      </div>

      {product.map((prdct) => (
        <div key={`desc-spec-${prdct.productID}`} className="product-specs">
          <div>
            <h4>Description</h4>
            <p>{prdct.description}</p>
          </div>

          <div>
            <h4>Specifications</h4>

            <h5 className="section-heading">General</h5>
            <div className="spec-grid">
              {renderSpec("Type", prdct.type)}
              {renderSpec("Model Number", prdct.modelNumber)}
              {renderSpec("Color", prdct.color)}
              {renderSpec("Speed", prdct.speed)}
              {renderSpec("Weight", prdct.weight)}
              {renderSpec("Country of Origin", prdct.countryOfOrigin)}
              {renderSpec("Manufacturer", prdct.manufacturer)}
            </div>

            <h5 className="section-heading">Power Features</h5>
            <div className="spec-grid">
              {renderSpec("Battery Type", prdct.batteryType)}
              {renderSpec(
                "Battery Included",
                prdct.batteryIncluded ? "Yes" : "No"
              )}
              {renderSpec("Rechargeable", prdct.rechargeable ? "Yes" : "No")}
            </div>

            <h5 className="section-heading">Convenience Features</h5>
            <div className="spec-grid">
              {renderSpec(
                "Parental Remote",
                prdct.parentalRemote ? "Yes" : "No"
              )}
              {renderSpec(
                "MP3 Player Supported",
                prdct.mpThreePlayerSupported ? "Yes" : "No"
              )}
              {renderSpec(
                "Other Convenience Features",
                prdct.otherConvenienceFeatures
              )}
            </div>

            <h5 className="section-heading">Dimensions</h5>
            <div className="spec-grid">
              {renderSpec("Dimensions", prdct.dimentions)}
              {renderSpec("Maximum User Weight", prdct.maximumUserWeight)}
            </div>

            <h5 className="section-heading">Warranty</h5>
            <div className="spec-grid">
              {renderSpec("Warranty", prdct.warrenty)}
              {renderSpec("Covered in Warranty", prdct.coveredInWarranty)}
              {renderSpec(
                "Not Covered in Warranty",
                prdct.notCoveredInWarranty
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
